import React, { Fragment, useState } from "react";
import { graphql } from "gatsby";
import classNames from "classnames";
import { Link } from "./link";
import Icon from "./elements/icon";
import Image from "./elements/image";
import CirclePlus from "../icons/circle-plus-light.svg";
import CircleMinus from "../icons/circle-minus-light.svg";
import safeSlugify from "../utility/safe-slugify";

const AccordionInfo = ({ data }) => {
  const [currentAccordionItem, setCurrentAccordionItem] = useState(0);

  const toggleAccordionItem = (e) => {
    const index = parseInt(e.currentTarget.getAttribute("data-index"));
    setCurrentAccordionItem(index);
  };

  function stringOpacityToDecimal(opacity) {
    if (opacity === "low") {
      return 0.2;
    } else if (opacity === "medium") {
      return 0.4;
    } else if (opacity === "high") {
      return 0.7;
    }
  }

  const regHex = /^#([0-9a-f]{3}){1,2}$/i;
  const accordionData = data?.accordionInfo.filter((item) => item.title);
  return (
    <>
      {data?.anchorTitleDesktop && (
        <span id={safeSlugify(data.anchorTitleDesktop)} className="tabs__scroll-anchor" />
      )}
      <div
        className="categoryHighlight"
        style={
          accordionData?.[currentAccordionItem]?.backgroundImage
            ? {
                backgroundImage:
                  accordionData?.[currentAccordionItem]?.imageOpacity?.length > 0
                    ? `linear-gradient(to left,rgba(0,0,0, ${stringOpacityToDecimal(
                        accordionData?.[currentAccordionItem]?.imageOpacity?.[0]
                      )}), transparent), url("${
                        accordionData?.[currentAccordionItem].backgroundImage.node.publicURL
                      }")`
                    : `url("${accordionData?.[currentAccordionItem].backgroundImage.node.publicURL}")`,
              }
            : {
                background:
                  data.backgroundColor?.[0] === "light"
                    ? "linear-gradient(180deg, #d5d5d5 0%, rgba(0, 0, 0, 0.1) 100%)"
                    : data.backgroundColor?.[0] === "dark"
                    ? "linear-gradient(180deg, #1d1d1d 0%, rgba(0, 0, 0, 0.5) 100%)"
                    : regHex.test(accordionData?.[currentAccordionItem].backgroundColorHex)
                    ? accordionData?.[currentAccordionItem].backgroundColorHex
                    : null,
              }
        }
      >
        <div className="categoryHighlight__image">
          {accordionData?.[currentAccordionItem]?.badgeText && (
            <div className="message">
              <p>{accordionData?.[currentAccordionItem].badgeText}</p>
              {accordionData?.[currentAccordionItem].content?.badgeIcon && (
                <Icon
                  url={
                    accordionData?.[currentAccordionItem]?.badgeIcon?.node?.resize?.src ||
                    accordionData?.[currentAccordionItem]?.badgeIcon?.node?.publicURL
                  }
                  name="custom"
                  width={50}
                />
              )}
            </div>
          )}
          {accordionData?.[currentAccordionItem].image && (
            <Image
              image={accordionData?.[currentAccordionItem].image}
              alt={accordionData?.[currentAccordionItem].image.value?.description || ""}
              className="categoryHighlight__image--img"
            />
          )}
        </div>

        <div className="categoryHighlight__category">
          {accordionData.map((item, i) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div
              className={classNames(
                "categoryHighlight__category_tab",
                currentAccordionItem === i && "open"
              )}
              key={i}
              data-index={i}
              onClick={toggleAccordionItem}
              data-bg="#77C5D3"
            >
              <div className="inner">
                <div
                  className={classNames(
                    "categoryHighlight__category_tab_heading",
                    data.backgroundColor?.[0] === "light" ? "light-theme" : "dark-theme"
                  )}
                >
                  <span>{item?.title}</span>
                  <div
                    className={classNames(
                      "categoryHighlight__category_tab_heading_icon",
                      data.backgroundColor?.[0] === "light" ? "light-theme" : "dark-theme"
                    )}
                  >
                    <span className="icon">
                      {currentAccordionItem === i ? (
                        // <Icon className="storybook" color="white" name="symbols-minus" />
                        <CircleMinus
                          className={classNames(
                            "minus",
                            data.backgroundColor?.[0] === "light"
                              ? "light-theme--icon"
                              : "dark-theme--icon"
                          )}
                        />
                      ) : (
                        // <Icon className="storybook" color="white" name="symbols-plus" />
                        <CirclePlus
                          className={classNames(
                            "plus",
                            data.backgroundColor?.[0] === "light"
                              ? "light-theme--icon"
                              : "dark-theme--icon"
                          )}
                        />
                      )}
                    </span>
                  </div>
                </div>
                <div className="categoryHighlight__category_tab_content">
                  <p
                    className={classNames(
                      "categoryHighlight__category_tab_content_title",
                      data.backgroundColor?.[0] === "light" ? "light-theme" : "dark-theme"
                    )}
                  >
                    {item?.subtitle}
                  </p>
                  {item.content
                    .sort((a, b) =>
                      a.position[0] > b.position[0] ? 1 : b.position[0] > a.position[0] ? -1 : 0
                    )
                    .map((items, index) => (
                      <Fragment key={index}>
                        {items.abstract && (
                          <p
                            className={classNames(
                              "categoryHighlight__category_tab_content_description",
                              data.backgroundColor?.[0] === "light" ? "light-theme" : "dark-theme"
                            )}
                            dangerouslySetInnerHTML={{
                              __html: items.abstract,
                            }}
                          ></p>
                        )}
                        {items.icons?.filter((icon) => icon.iconText).length > 0 && (
                          <ul className="categoryHighlight__category_tab_content_list">
                            {items.icons
                              .filter((icon) => icon?.iconText && icon.iconText !== "")
                              .map((icon, i) => (
                                <li
                                  className={classNames(
                                    "categoryHighlight__category_tab_content_item",
                                    data.backgroundColor?.[0] === "light"
                                      ? "light-theme"
                                      : "dark-theme"
                                  )}
                                  key={i}
                                >
                                  {icon && (
                                    <Icon
                                      className="storybook categoryHighlight__category_tab_content_item_icon"
                                      name={
                                        icon?.haierStEcommIcons?.alternativeIcon ? "custom" : null
                                      }
                                      url={
                                        icon?.haierStEcommIcons?.alternativeIcon?.node?.resize
                                          ?.src ||
                                        icon?.haierStEcommIcons?.alternativeIcon?.node?.publicURL
                                      }
                                      color={"white"}
                                    />
                                  )}
                                  <p
                                    className={classNames(
                                      data.backgroundColor?.[0] === "light"
                                        ? "light-theme"
                                        : "dark-theme"
                                    )}
                                  >
                                    {" "}
                                    {icon.iconText}
                                  </p>
                                </li>
                              ))}
                          </ul>
                        )}
                      </Fragment>
                    ))}

                  {item?.cta?.ctaLink && item?.cta?.ctaLabel && (
                    <div className="categoryHighlight__category_tab_content_list">
                      <Link
                        className={classNames(
                          "btn-link",
                          item.cta?.ctaColor?.[0] === "white" && "btn-link--white"
                        )}
                        target={item.cta?.ctaTarget}
                        to={item.cta.ctaLink}
                      >
                        {item.cta.ctaLabel}
                      </Link>
                    </div>
                  )}
                  {item?.additionalNotes && (
                    <p
                      className={classNames(
                        "categoryHighlight__category_tab_content_footer",
                        data.backgroundColor?.[0] === "light" ? "light-theme" : "dark-theme"
                      )}
                      dangerouslySetInnerHTML={{
                        __html: item.additionalNotes,
                      }}
                    ></p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AccordionInfo;

export const fragment = graphql`
  fragment AccordionInfoFragment on LiferayAccordionInfo {
    anchorTitleDesktop
    anchorTitleMobile
    backgroundColor
    accordionInfo: accordion {
      title
      backgroundColorHex
      imageOpacity
      content {
        abstract
        position
        icons {
          iconText
          haierStEcommIcons {
            alternativeIcon {
              value {
                description
              }
              node {
                gatsbyImageData(layout: FULL_WIDTH)
                publicURL
                resize {
                  src
                }
              }
            }
          }
        }
      }
      additionalNotes
      backgroundImage {
        value {
          description
        }
        node {
          gatsbyImageData(layout: FULL_WIDTH)
          publicURL
        }
      }
      badgeIcon {
        value {
          description
        }
        node {
          gatsbyImageData(layout: FULL_WIDTH)
          publicURL
          resize {
            src
          }
        }
      }
      subtitle
      image {
        node {
          publicURL
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
        value {
          description
        }
      }
      badgeText
      cta {
        ctaLink
        ctaColor
        ctaLabel
        ctaTarget
      }
    }
  }
`;
